const { default: messages } = require('../services/messages')


function getLanguageOnLocalstorage() {
    const language = localStorage.getItem('language')    
    const null_langueges = ['null', 'undefined', '']    
    if (null_langueges.includes(language)) {    
        const portugueseCode = 1    
        return  portugueseCode    
    }
    return language
}
function displayMessage(index, params = []) {
    try {
        const br_code = 1
        const language = getLanguageOnLocalstorage() || br_code
        let message = messages[index][language];
        if (!message) {
            return '-'
        }

        if (typeof params == 'object' && params != null && params.length > 0) {
            for (let i = 0; i < params.length; i++) {
                const param = params[i];
                // const re = new RegExp(`/{${i}}/`, 'g')
                // message = message.replace(re, param)
                message = message.split(`{${i}}`).join(param)
            }
        }
        return message
    } catch (error) {
        console.log(error)
        return '-'
    }
}
function checkEmptyNullObj(Obj) {
    if (typeof Obj != 'object' || !Obj || Object.keys(Obj).length == 0) {
        return true
    }

    return false
}

module.exports = { displayMessage, checkEmptyNullObj }